import { render, staticRenderFns } from "./ContactStatusCountTable.vue?vue&type=template&id=dad75b8c&scoped=true&"
import script from "./ContactStatusCountTable.vue?vue&type=script&lang=js&"
export * from "./ContactStatusCountTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactStatusCountTable.vue?vue&type=style&index=0&id=dad75b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad75b8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
